import { render, staticRenderFns } from "./markupsPopupMinimized.vue?vue&type=template&id=9fd3c07c"
import script from "./markupsPopupMinimized.vue?vue&type=script&lang=js"
export * from "./markupsPopupMinimized.vue?vue&type=script&lang=js"
import style0 from "./markupsPopupMinimized.vue?vue&type=style&index=0&id=9fd3c07c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports